import python from "../../assets/icons/python.svg";
import html from "../../assets/icons/html-5.svg";
import css from "../../assets/icons/css.svg";
import react from "../../assets/icons/react-js.svg";
import bootstrap from "../../assets/icons/bootstrap-4.svg";
import figma from "../../assets/icons/figma.svg";
import photoshop from "../../assets/icons/adobe-photoshop.svg";
import illustrator from "../../assets/icons/adobe-illustrator.svg";

const languages = [
  {
    icon: html,
    name: "HTML",
    level: "85",
  },
  {
    icon: css,
    name: "CSS",
    level: "70",
  },
  {
    icon: react,
    name: "react",
    level: "60",
  },

  {
    icon: bootstrap,
    name: "Bootstrap",
    level: "80",
  },
  {
    icon: python,
    name: "Python",
    level: "35",
  },
];

const tools = [
  {
    icon: figma,
    name: "Figma",
    level: "55",
  },
  {
    icon: photoshop,
    name: "Photoshop",
    level: "45",
  },
  {
    icon: illustrator,
    name: "Illustrator",
    level: "60",
  },
];

export { tools, languages };
